function bytesToSize(bytes) {
  if(typeof bytes !== 'number') return {};

  const units = ["byte", "kilobyte", "megabyte", "gigabyte", "terabyte"];
  const unit = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / 1024 ** unit;
  const formated = new Intl.NumberFormat("en", {style: "unit", unit: units[unit]}).format(size);
  const prefix = formated.split(/\s/)?.[1];

  return {
    formated,
    size,
    prefix
  }
}

export default bytesToSize;
